function _legend() { //TODO: legend의 경우 bar 만의 특수한 조건이 없으므로 Default에서 공유
  let legendToggle = this.legend();
  if (!legendToggle) return;
  if (!this.isColor()) { //mono 이면서 dimensions 1개인 경우 축 필요 없음
    return; 
  }
  this.renderLegend();
}

export default _legend;


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/scatter/_legend.js